export default __webpack_public_path__ + "static/media/crate-items_v1_5.6b0390f4.jpg";